import { getPaginationLimitOptions } from 'utils';

export const paginationLimits = [5, 10, 15];
export const paginationLimitOptions = getPaginationLimitOptions(paginationLimits);

export const detailsPaginationLimits = [10, 20, 30];
export const detailsPaginationLimitOptions = getPaginationLimitOptions(detailsPaginationLimits);
